export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4075b080ba5e95d4edc74e878ff0aec4442e6f7ec8&name=revalidateCommunity!'